<template>
<div class="container">
  <z-fix-top
      keep-position
      class="fixtop"
      :zIndex="navTitle ? 50 : 1"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          :title="navTitle"
          @click-left="closePage"
      ></z-nav-bar>
    </z-fix-top>
  <div class="report-detail" ref="scrollContainer" @scroll.passive="judgeScroll">
    <div class="report-detail-status">
      <div>{{ statusMap[reportDetial.status]}}</div>
      <div>{{ reportDetial.status == '2' ? `${reportDetial.remainingTime}后，补充证据入口将关闭`  : reportDetial.notice}}</div>
    </div>
    <div class="report-detail-content">
      <div class="report-detail-content-container" v-if="reportDetial.status != '0'">
        <!-- 反馈结果 -->
        <result-card :infoData="reportDetial"></result-card>
      </div>
      <div class="report-detail-content-container">
        <!-- 补充凭证信息 -->
        <supply-card :infoData="reportDetial"></supply-card>
      </div>
      <div class="report-detail-content-container">
        <!-- 举报信息 -->
        <info-card :infoData="reportDetial"></info-card>
      </div>
      <div class="report-detail-content-container" v-if="['1','3'].includes(reportDetial.reportType)">
        <!-- 举报列表 -->
        <report-card :infoData="reportDetial"></report-card>
      </div>
    </div>
  </div>
  <!-- 评价弹窗 -->
    <z-popup v-model="showPopup" position="bottom">
      <Evaluate @closeevaluate="hasCommment" @close="togglePopup"></Evaluate>
    </z-popup>

    <!-- 撤销举报弹窗 -->
    <z-popup :style="{height:'80%'}" v-model="showRevokePopup" position="bottom">
      <RevokeReport @close="toggleRevokePopup"></RevokeReport>
    </z-popup>
    <!-- 底部按钮 -->
    <z-button-group v-show="showBottomNav" class="bottom-button">
      <!-- <z-button size="small-detail" v-show="showRevoke" @click="toggleRevokePopup">撤销举报</z-button>
      <z-button size="small-detail" v-show="showPaymoney" @click="topPayMoney">申请赔付</z-button> -->
      <z-button size="small-detail" type="primary" v-show="showEvaluate" @click="togglePopup">去评价</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { Button, ButtonGroup, Popup, NavBar, FixTop } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import native from '@zz-common/native-adapter'
import { newReportGetDetail, newReportGetHasRead } from '@api/resourceApi'
// import { lego } from '@zz-common/lego'
import { toast } from '../../../native'
import { queryParams, getCookie } from '../../../lib/utils'
import InfoCard from './InfoCard'
import ReportCard from './ReportCard'
import ResultCard from './ResultCard'
import SupplyCard from './SupplyCard'
import Evaluate from './Evaluate'
import RevokeReport from './RevokeReport'

const query = queryParams()

export default {
  name: 'ReportDetial',
  data() {
    return {
      id: query.id || this.$route.query.id, //举报id
      uid: getCookie('uid'),
      toUid: query.toUid || this.$route.query.toUid, //对方uid
      reportDetial: {}, //详情信息
      showPopup: false, //弹窗显隐
      showRevokePopup: false,
      native,
      navTitle: '',
      statusMap: { //状态map
        0: '等待处理中',
        1: '已处理完成',
        2: '建议您补充举报证据'
      }
    }
  },
  components: {
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zPopup: Popup,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    InfoCard,
    ReportCard,
    ResultCard,
    SupplyCard,
    Evaluate,
    RevokeReport
  },
  computed: {
    pic() {
      const { pics = '' } = this.reportDetial
      if (pics === '' || pics === '|') return []
      return pics.split('|')
    },
    //显示底部按钮
    showBottomNav() {
      return this.showEvaluate || this.showPaymoney || this.showRevoke
    },
    //显示评价
    showEvaluate() {
      return this.reportDetial.iappraise == '0' && this.reportDetial.status == '1'
    },
    //显示赔付
    showPaymoney() {
      return !!this.reportDetial.compensate
    },
    //显示撤销举报
    showRevoke() {
      return !!this.reportDetial.backReport
    }
  },
  provide() {
    return {
      id: this.id,
      toUid: this.toUid
    }
  },
  methods: {
    setPicSize,
    closePage() {
      native.close()
    },
    toggleRevokePopup() {
      this.showRevokePopup = !this.showRevokePopup
    },
    togglePopup() {
      this.showPopup = !this.showPopup
    },
    hasCommment() {
      this.reportDetial.iappraise = '1'
    },
    init() {
      this.getReotDetial()
    },
    //赔付打款页面
    topPayMoney() {
      const targetUrl = `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySelect&toUid=${this.toUid}&applySource=report`
      native.skipToUrl({
        targetUrl
      })
    },
    //获取详情信息
    getReotDetial() {
      this.fetchLoading = true
      return newReportGetDetail({
        id: this.id,
        uid: this.uid,
        toUid: this.toUid
      })
        .then((res) => {
          this.fetchLoading = false
          this.reportDetial = res
          console.log('详情res', res)
          return res
        })
        .catch((err) => {
          this.fetchLoading = false
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    judgeScroll() {
      if (this.$refs.scrollContainer.scrollTop >= 20 && this.navTitle == '') {
        this.navTitle = this.statusMap[this.reportDetial.status]
      } else if (this.$refs.scrollContainer.scrollTop < 10) {
        this.navTitle = ''
      }
    }
  },
  mounted() {
    this.init()
    newReportGetHasRead({
      reportId: this.id
    })
  }
}
</script>

<style scoped lang="less">
  @import 'ReportDetial.less';
</style>
